module.exports = __webpack_public_path__ + "img/block_4_img.3fc0852a.png";